import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

import { neutral } from '_lex/_foundations/phxColors';
import { TemplateSection } from '../../_types';

interface SectionDragOverlayProps {
  section: TemplateSection;
}

const SectionDragOverlay: React.FC<SectionDragOverlayProps> = ({ section }) => {
  return (
    <Paper
      sx={{
        border: '1px solid',
        borderColor: neutral[300],
        borderRadius: 2,
        overflow: 'hidden',
        boxShadow: 3,
        opacity: 0.95,
        minWidth: 300,
        maxWidth: 600,
        cursor: 'grabbing',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          p: 2,
          backgroundColor: neutral[50],
          borderBottom: '1px solid',
          borderBottomColor: neutral[200],
        }}
      >
        <Typography
          variant='subtitle1'
          fontWeight='bold'
          sx={{ flex: 1 }}
        >
          {section.effectiveName}
        </Typography>
      </Box>
      <Box sx={{ p: 2 }}>
        <Typography
          variant='caption'
          color='text.secondary'
        >
          {section.sectionFields.length} field{section.sectionFields.length !== 1 ? 's' : ''}
        </Typography>
      </Box>
    </Paper>
  );
};

export default SectionDragOverlay;
